// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

const NG_PHONE_REGEX = /^\+234 (?!234)\d{8,12}$/;

export function validateNigerianPhoneNumber(phoneNumberValue: string): ?UserInputValidationError {
  if (!phoneNumberValue || !phoneNumberValue.trim() || !parseInt(phoneNumberValue)) {
    return { id: 'empty' };
  } else if (!NG_PHONE_REGEX.test(phoneNumberValue) || phoneNumberValue.length < 13) {
    return { id: 'invalid-pattern' };
  }
}
